import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-global-line text-background-50 text-lg"></i>
            </div>
            <span className="font-heading font-bold text-lg text-foreground-900">
              亚洲精品一区二区
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link to="/" className="text-foreground-700 hover:text-primary-600 transition-colors text-sm whitespace-nowrap cursor-pointer">
              首页
            </Link>
            <Link to="/category/yiqu" className="text-foreground-700 hover:text-primary-600 transition-colors text-sm whitespace-nowrap cursor-pointer">
              一区精品
            </Link>
            <Link to="/category/erqu" className="text-foreground-700 hover:text-primary-600 transition-colors text-sm whitespace-nowrap cursor-pointer">
              二区资源
            </Link>
            <Link to="/category/zonghe" className="text-foreground-700 hover:text-primary-600 transition-colors text-sm whitespace-nowrap cursor-pointer">
              综合导览
            </Link>
            <Link to="/about" className="text-foreground-700 hover:text-primary-600 transition-colors text-sm whitespace-nowrap cursor-pointer">
              关于我们
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-3">
            <Link to="/" className="text-foreground-700 text-sm py-2 cursor-pointer" onClick={() => setMobileOpen(false)}>首页</Link>
            <Link to="/category/yiqu" className="text-foreground-700 text-sm py-2 cursor-pointer" onClick={() => setMobileOpen(false)}>一区精品</Link>
            <Link to="/category/erqu" className="text-foreground-700 text-sm py-2 cursor-pointer" onClick={() => setMobileOpen(false)}>二区资源</Link>
            <Link to="/category/zonghe" className="text-foreground-700 text-sm py-2 cursor-pointer" onClick={() => setMobileOpen(false)}>综合导览</Link>
            <Link to="/about" className="text-foreground-700 text-sm py-2 cursor-pointer" onClick={() => setMobileOpen(false)}>关于我们</Link>
          </div>
        </div>
      )}
    </nav>
  );
}